import { render, staticRenderFns } from "./ApplyMOBILE.vue?vue&type=template&id=50795066&scoped=true"
import script from "./ApplyMOBILE.vue?vue&type=script&lang=js"
export * from "./ApplyMOBILE.vue?vue&type=script&lang=js"
import style0 from "./ApplyMOBILE.vue?vue&type=style&index=0&id=50795066&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50795066",
  null
  
)

export default component.exports